@if (vm(); as vm) {
	@if (
		!(
			(vm.vsnFeeCollection?.globalOptIn === null && vm.vsnFeeCollection?.eligibleForVsn === false) ||
			vm.vsnFeeCollection?.globalOptIn === false ||
			vm.vsnFeeCollection?.eligibleForVsn === false
		)
	) {
		@if (
			vm.vsnFeeCollection?.globalOptIn &&
			vm.vsnFeeCollection?.eligibleForVsn &&
			vm.vsnFeeCollection?.visionFeeDetail?.hasEnoughFunds &&
			vm.vsnFeeCollection?.enabled
		) {
			@let _selectedCurrency = selectedCurrency();
			<div class="bonus">
				<div class="left">
					@if (vm.vsnFeeCollection?.visionFeeDetail?.bonus?.type === bonusType.Asset) {
						{{ "fee_transparency_details_your_bonus" | translate }}
					} @else {
						@if (_selectedCurrency === selectedCurrencyType.CRYPTOCOIN) {
							{{ "fee_transparency_details_you_get" | translate }}
						} @else {
							{{ "fee_transparency_details_you_save" | translate }}
						}
					}
				</div>
				<div class="right">
					@if (vm.vsnFeeCollection?.visionFeeDetail?.bonus?.type === bonusType.Asset) {
						+{{
							vm.vsnFeeCollection?.visionFeeDetail?.bonus?.amount
								| tradable_precision_symbol
									: {
											id: vm.tradable.getId(),
											symbol: true,
											ignorePrecision: true
									  }
						}}
					} @else {
						@if (_selectedCurrency === selectedCurrencyType.CRYPTOCOIN) {
							+
						}

						{{
							vm.vsnFeeCollection?.visionFeeDetail?.bonus?.amount
								| fiat_precision_symbol
									: {
											id: vm.fiat?.getId(),
											currencies: [vm.fiat],
											symbol: true
									  }
						}}
					}
				</div>
			</div>
		}

		<div class="total">
			<div class="left">{{ "amount_total" | translate }}</div>
			<div class="right">
				{{
					vm?.total
						| fiat_precision_symbol
							: {
									id: vm?.fiat?.getId(),
									currencies: [vm?.fiat],
									symbol: true
							  }
				}}</div
			>
		</div>
	}
}
